import actions from './he-IL/actions';
import admin from './he-IL/admin';
import common from './he-IL/common';
import error from './he-IL/error';
import features from './he-IL/features';
import form from './he-IL/form';
import menu from './he-IL/menu';
import messages from './he-IL/messages';
import price from './he-IL/price';
import scheduler from './he-IL/scheduler';
import subscriptions from './he-IL/subscriptions';
import table from './he-IL/table';
import tenants from './he-IL/tenants';

export default {
  ...actions,
  ...admin,
  ...common,
  ...error,
  ...form,
  ...menu,
  ...features,
  ...messages,
  ...price,
  ...table,
  ...tenants,
  ...subscriptions,
  ...scheduler,
};
